<template>
    <app-layout>
        <page-header :title="trans('settings.overview.title')" title-in-app-header />

        <div v-if="show_branding" class="row">
            <div class="col-md-6">
                <update-tenant-logo-form :can-update="can_update_branding" />
            </div>
        </div>

        <template v-if="resolvedSections.length">
            <h2 class="mt-4 mb-3 text-lg font-semibold text-gray-body">{{ trans('settings.overview.more.title') }}</h2>
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                <Link
                    v-for="section in resolvedSections"
                    :key="section.key"
                    :href="route(section.route)"
                    class="flex items-start gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:border-primary hover:shadow"
                >
                    <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary text-primary">
                        <icon :name="section.icon" size="lg" />
                    </span>
                    <div class="min-w-0">
                        <div class="font-semibold text-gray-body">{{ section.title }}</div>
                        <div class="text-sm text-gray-400">{{ section.description }}</div>
                    </div>
                </Link>
            </div>
        </template>
    </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Components/PageHeader.vue';
import Icon from '@/Components/Icon.vue';
import UpdateTenantLogoForm from '@/Pages/Settings/UpdateTenantLogoForm.vue';
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    show_branding: {
        type: Boolean,
        default: false,
    },
    can_update_branding: {
        type: Boolean,
        default: false,
    },
    sections: {
        type: Array,
        default: () => [],
    },
});

// Separate admin pages linked from the hub; view concerns (route + icon) keyed
// by the section identifiers the backend authorizes.
const SECTION_DEFINITIONS = {
    permissions: { route: 'permissions.index', icon: 'cil-lock-locked' },
    notification_settings: { route: 'notification-settings.index', icon: 'cil-bell' },
    subscriptions: { route: 'subscriptions.index', icon: 'cil-list' },
};

const resolvedSections = computed(() =>
    props.sections
        .filter((key) => key in SECTION_DEFINITIONS)
        .map((key) => ({
            key,
            route: SECTION_DEFINITIONS[key].route,
            icon: SECTION_DEFINITIONS[key].icon,
            title: trans(`settings.overview.sections.${key}.title`),
            description: trans(`settings.overview.sections.${key}.description`),
        })),
);
</script>
